import { gql } from '@apollo/client';

export const GET_COMPANY_STATUSES = gql`
	query GetCompanyStatuses {
		companyStatuses {
			id
			name
			code
			group {
				id
				name
				code
				sort
				createdAt
			}
			sort
			createdAt
		}
	}
`;
